import { URLS } from 'config';
import { useEnquiryContext } from 'pages/Enquiry/context';
import { useCallback } from 'react';
import { generatePath, useHistory } from 'react-router-dom';
import { scrollToTop } from 'utils';

export interface EnquiryQuoteWelcomeHook {
  onClick: () => void;
  tradingName: string;
  isLoading: boolean;
}

export default function useEnquiryQuoteWelcome(): EnquiryQuoteWelcomeHook {
  const { id, tradingName, isLoading } = useEnquiryContext();
  const { push } = useHistory();

  const onClick = useCallback(() => {
    if (!id) return;
    scrollToTop();
    push(generatePath(URLS.enquiryQuoteContactDetails, { id }));
  }, [id, push]);

  return { onClick, tradingName, isLoading };
}
